import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";

export interface GrupoCondominio {
  id: number;
  nome: string;
  condominios: Condominio[];
  excluido: boolean;
}

export interface Condominio {
  condominioId: number;
  nomeFantasia: string;
  cnpj: string;
  possuiCertificadoConfigurado: boolean;
}

export const useGetGrupoCondominios = () => {
  const onError = () => {
    toast.error("Erro ao carregar grupos de condomínios");
  };
  
  return useFetch<Cond21CloudResponse<GrupoCondominio[]>>({
    key: ["grupo-condominios"],
    url: api.condominio.getGrupoCondominios, 
    onError,
  });
};